import React, { useState } from "react";
import Slider from "react-slick";

import arif from "../../src/assets/img/testimonials/arif.webp";
import sonu from "../../src/assets/img/testimonials/sonu.webp";
import yogita from "../../src/assets/img/testimonials/1701A010137.webp";
import teenu from "../../src/assets/img/testimonials/1702A010279.webp";
import gajendra from "../../src/assets/img/testimonials/1702A010427.webp";
import topeshwar from "../../src/assets/img/testimonials/1702A020495.webp";
import himalaya from "../../src/assets/img/testimonials/1801A020678.webp";
import jagriti from "../../src/assets/img/testimonials/1801A021590.webp";
import hemant from "../../src/assets/img/testimonials/2102A0300411.webp";
import chhaya from "../../src/assets/img/testimonials/2201A0100432.webp";
import durgeshwari from "../../src/assets/img/testimonials/2201A0300341.webp";
import abhishek_bca from "../../src/assets/img/testimonials/2202A0100195.webp";
import kuleshwar from "../../src/assets/img/testimonials/2202A0100956.webp";
import niranjan from "../../src/assets/img/testimonials/2202A0200756.webp";
import suresh from "../../src/assets/img/testimonials/2202A0201068.webp";
import isha from "../../src/assets/img/testimonials/2301A0100157.webp";
import ekta from "../../src/assets/img/testimonials/2301A0100360.webp";
import gitika from "../../src/assets/img/testimonials/2301A0202771.webp";
import vamini from "../../src/assets/img/testimonials/2301A0203109.webp";
import naveen from "../../src/assets/img/testimonials/2302A0100211.webp";
import hemant_k from "../../src/assets/img/testimonials/2302A0101025.webp";
import guruvachan from "../../src/assets/img/testimonials/2302A0102279.webp";
import yogesh_c from "../../src/assets/img/testimonials/2302A0102290.webp";
import devid from "../../src/assets/img/testimonials/2302A0102920.webp";
import aashish_d from "../../src/assets/img/testimonials/2302A0102930.webp";
import yogesh_d from "../../src/assets/img/testimonials/2302A0201854.webp";
import yash from "../../src/assets/img/testimonials/2302A0202659.webp";
import aastha from "../../src/assets/img/testimonials/2401A0100036.webp";
import sunita from "../../src/assets/img/testimonials/2401A0100161.webp";
import gunjan from "../../src/assets/img/testimonials/2401A0100238.webp";
import hemlata from "../../src/assets/img/testimonials/2401A0100584.webp";
import palak from "../../src/assets/img/testimonials/2401A0100587.webp";
import roshanee from "../../src/assets/img/testimonials/2401A0100862.webp";
import bushra from "../../src/assets/img/testimonials/2401A0200027.webp";
import suman from "../../src/assets/img/testimonials/2401A0201800.webp";
import divya_s from "../../src/assets/img/testimonials/2401A0202013.webp";
import yeshu from "../../src/assets/img/testimonials/2402A0100026.webp";
import lakhan from "../../src/assets/img/testimonials/2402A0100153.webp";
import dikshit from "../../src/assets/img/testimonials/2402A0100195.webp";
import kartik from "../../src/assets/img/testimonials/2402A0100310.webp";
import vikas from "../../src/assets/img/testimonials/2402A0100378.webp";
import akshat from "../../src/assets/img/testimonials/2402A0100427.webp";
import lukesh from "../../src/assets/img/testimonials/2402A0100512.webp";
import ojasva from "../../src/assets/img/testimonials/2402A0100847.webp";
import praveen from "../../src/assets/img/testimonials/2402A0100863.webp";
import bedram from "../../src/assets/img/testimonials/2402A0100973.webp";
import aashish_k from "../../src/assets/img/testimonials/2402A0101246.webp";
import riyansh from "../../src/assets/img/testimonials/2402A0101771.webp";
import bhaskar from "../../src/assets/img/testimonials/2402A0101869.webp";
import piyush from "../../src/assets/img/testimonials/2402A0201606.webp";
import tukeshwar from "../../src/assets/img/testimonials/2402A0201831.webp";
import gajanand from "../../src/assets/img/testimonials/2402A0201867.webp";
import kavita from "../../src/assets/img/testimonials/kavita.webp";
import vrishti from "../../src/assets/img/testimonials/vrishti.webp";
import pushpendra from "../../src/assets/img/testimonials/pushpendra.webp";
import sakshi from "../../src/assets/img/testimonials/sakshi.webp";
import gaurav from "../../src/assets/img/testimonials/gaurav.webp";
import abhisheksingh from "../../src/assets/img/testimonials/abhishek.webp";
import kevil from "../../src/assets/img/testimonials/kevil.webp";
import amit from "../../src/assets/img/testimonials/amit.webp";
import divya from "../../src/assets/img/testimonials/divya.webp";
// import sumit from "../../src/assets/img/testimonials/user.webp";
import tilendra from "../../src/assets/img/testimonials/tilendra.webp";
// import na from "../../src/assets/img/testimonials/user.webp";
import satya from "../../src/assets/img/testimonials/SATYA PATEL (MSc MICROBIOLOGY).webp";
import ayush from "../../src/assets/img/testimonials/AYUSH RANJAN SINGH (B.TECH MINING).webp";
import narayan from "../../src/assets/img/testimonials/NARAYAN MOHANTY (B.TECH MINING).webp";
import pravriti from "../../src/assets/img/testimonials/PRAVRITI PANDEY (MBA).webp";
import devrat from "../../src/assets/img/testimonials/DEVVRAT BAG(BBA.LLB).webp";
import "../assets/css/alumni.css";

function Alumni() {
    const alumniData = [
        {
            id: 1,
            name: "MD Arif",
            field: "",
            testimonial:
                "I am incredibly grateful to ISBM University for providing me with the opportunity to secure my dream job. The university not only equipped me with essential skills but also nurtured my potential for growth.",
            image: arif,
        },
        {
            id: 2,
            name: "Shivam Pandey",
            field: "",
            testimonial:
                "My journey with ISBM University has been both enriching and empowering. The in-depth curriculum and dedicated faculty provided me with skills to thrive in the industry.",
            image: sonu,
        },
        {
            id: 3,
            name: "Kavita Sahu",
            field: "BBA ",
            testimonial:
                "The BBA program at ISBMU gave me strong business knowledge and real industry exposure. The faculty are supportive, and the projects and internships helped me gain confidence and practical skills. ISBMU has truly prepared me for my career.",
            image: kavita,
        },

        {
            id: 5,
            name: "Gaurav Soni",
            field: "MSc Chemistry ",
            testimonial:
                "My MSc Chemistry at ISBMU has been very good. Teachers are helpful, labs are well equipped, and I have learned a lot. It is a great place to study.",
            image: gaurav,
        },
        {
            id: 6,
            name: "Sakshi Bisen",
            field: "B.Tech IT ",
            testimonial:
                "My journey in B.Tech IT at ISBMU has been full of learning and growth. The coding sessions, labs, and projects gave me real practical knowledge. The teachers always guide us and make learning easy.",
            image: sakshi,
        },
        {
            id: 7,
            name: "Pushpendra Singh",
            field: "Library Science ",
            testimonial:
                "The Library Science course at ISBM University gave me good knowledge of books, digital resources, and library management. The teachers are helpful and the course is very practical. It has prepared me well for future jobs.",
            image: pushpendra,
        },
        {
            id: 8,
            name: "Abhishek Singh",
            field: "BBA ",
            testimonial:
                "Studying BBA at ISBM University has been a good experience. The course gave me clear knowledge of management and business concepts. The faculty are supportive and guide us well, which makes learning easier and more practical.",
            image: abhisheksingh,
        },
        {
            id: 9,
            name: "Kevil Kumar Devanga ",
            field: "School of Arts ",
            testimonial:
                "The School of Arts at ISBM University gave me the chance to explore my creativity and learn new skills. The classes are interactive, the teachers are encouraging, and I gained confidence to express myself better through art.",
            image: kevil,
        },
        {
            id: 10,
            name: "Amit Sahu",
            field: "B.Sc ",
            testimonial:
                "The B.Sc. program at ISBM University helped me build strong knowledge in science subjects. The teachers explain concepts clearly, and the practical sessions made learning more interesting and useful for my future career.",
            image: amit,
        },
        {
            id: 67,
            name: "Devrat Bag",
            field: "BBA LLB ",
            testimonial:
                "The BBA LLB journey at ISBM University has been a great experience. The faculty guided me well in both management and law, and the supportive staff made learning comfortable and easy.",
            image: devrat, // import devrat image
        },

        {
            id: 13,
            name: "Tilendra Kumar",
            field: "PGDCA ",
            testimonial:
                "The PGDCA program at ISBM University gave me good knowledge of computer applications. The teachers guide us well, the staff are supportive, and the labs have all the facilities needed for practical learning.",
            image: tilendra,
        },
        {
            id: 12,
            name: "Tukeshwar Sahu",
            field: "M.Sc Chemistry ",
            testimonial:
                "M.Sc. Chemistry here helped me love experiments and research. The support was always there.",
            image: tukeshwar,
        },
        {
            id: 14,
            name: "Gajanand",
            field: "M.Lib ",
            testimonial:
                "My MLIB course gave me advanced skills and confidence. ISBM University made me ready for the professional world.",
            image: gajanand,
        },
        {
            id: 15,
            name: "Yogita Sen",
            field: "B.Sc ",
            testimonial:
                "ISBM University has given me the right environment to explore science. The teachers always encourage us to ask questions, and I feel more confident about my future.",
            image: yogita,
        },
        {
            id: 16,
            name: "Teenu Anand",
            field: "B.Sc ",
            testimonial:
                "My journey in B.Sc. has been wonderful. I have received not only knowledge, but also guidance and care from teachers who treat us like family.",
            image: teenu,
        },
        {
            id: 17,
            name: "Gajendra Kumar Dhruw ",
            field: " B.Sc Computer Science ",
            testimonial:
                "The computer labs, supportive staff, and practical approach at ISBM University have helped me grow in confidence. I can now dream bigger in the field of IT.",
            image: gajendra,
        },
        {
            id: 18,
            name: "Topeshwar Prasad",
            field: "M.Sc Botany ",
            testimonial:
                "Studying Botany here has connected me with nature and research. The modern labs and helpful faculty made every experiment meaningful.",
            image: topeshwar,
        },
        {
            id: 19,
            name: "Himalaya Sahu",
            field: "M.Sc Zoology ",
            testimonial:
                "My Zoology course at ISBM University gave me more than academic knowledge—it gave me passion for research and respect for my subject.",
            image: himalaya,
        },
        {
            id: 20,
            name: "Jagriti",
            field: "M.Sc Botany ",
            testimonial:
                "At ISBM University, I always felt supported. The faculty’s personal attention made me believe that I can achieve more in the field of Botany.",
            image: jagriti,
        },
        {
            id: 21,
            name: "Hemant",
            field: "PGDCA ",
            testimonial:
                "The PGDCA program gave me the confidence to handle real computer applications. Every class felt practical, and the staff encouraged me to keep learning.",
            image: hemant,
        },
        {
            id: 22,
            name: "Chhaya Sahu",
            field: "BCA ",
            testimonial:
                "My BCA journey at ISBM University has been exciting. From the first day, I felt motivated to learn technology in a creative way.",
            image: chhaya,
        },
        {
            id: 23,
            name: "Durgeshwari Sahu ",
            field: "B.Lib ",
            testimonial:
                "Library Science here gave me more than knowledge—it gave me pride in managing information and helping others learn.",
            image: durgeshwari,
        },
        {
            id: 24,
            name: "Abhishek",
            field: "BCA ",
            testimonial:
                "ISBM University gave me the chance to explore the IT world with real guidance. I feel prepared to face challenges in the industry.",
            image: abhishek_bca,
        },
        {
            id: 25,
            name: "Kuleshwar Kumar",
            field: "B.Sc ",
            testimonial:
                "My time in B.Sc. has been full of growth. The friendly environment and helpful teachers made me enjoy every subject.",
            image: kuleshwar,
        },
        {
            id: 26,
            name: "Niranjan Singh Nayak",
            field: "MBA ",
            testimonial:
                "The MBA program shaped me into a confident leader. The teaching at ISBM University connects theory with real business practices.",
            image: niranjan,
        },
        {
            id: 27,
            name: "Suresh Kumar",
            field: "MBA ",
            testimonial:
                "I never imagined learning could be this engaging. ISBM University gave me both knowledge and a network of mentors who inspire me.",
            image: suresh,
        },
        {
            id: 28,
            name: "Isha",
            field: "B.Sc ",
            testimonial:
                "ISBM University has been like a second home. The supportive staff and positive energy around the campus made my B.Sc. journey memorable.",
            image: isha,
        },
        {
            id: 29,
            name: "Ekta Tripathi",
            field: "BA LLB ",
            testimonial:
                "Law is not just about books, it’s about justice. At ISBM University, I learned to connect law with real life, thanks to amazing faculty support.",
            image: ekta,
        },
        {
            id: 30,
            name: "Gitika Chouhan",
            field: "MBA ",
            testimonial:
                "My MBA journey here has been life-changing. The confidence and exposure I got at ISBM University will always stay with me.",
            image: gitika,
        },
        {
            id: 31,
            name: "Vamini Sahu ",
            field: "B.Lib ",
            testimonial:
                "Through BLIB, I discovered my passion for managing knowledge. ISBM University gave me respect for books and digital resources alike.",
            image: vamini,
        },
        {
            id: 32,
            name: "Naveen Giri Goswami",
            field: "BCA ",
            testimonial:
                "The BCA course gave me not just computer skills, but also the courage to think innovatively. ISBM University made me believe in myself.",
            image: naveen,
        },
        {
            id: 33,
            name: "Hemant Kumar",
            field: "B.Com ",
            testimonial:
                "Studying commerce here gave me clarity and vision for my career. ISBM University shaped my path step by step.",
            image: hemant_k,
        },
        {
            id: 34,
            name: "Guruvachan Singh",
            field: "BCA ",
            testimonial:
                "The environment at ISBM University is so positive that learning feels natural. My BCA journey has been filled with growth.",
            image: guruvachan,
        },
        {
            id: 35,
            name: "Yogesh Kumar Chakradhari",
            field: "BCA ",
            testimonial:
                "ISBM University gave me real confidence in IT. Every project, every lab session added value to my journey.",
            image: yogesh_c,
        },
        {
            id: 36,
            name: "Devid Sahu",
            field: "LLB ",
            testimonial:
                "My dream to study law came true here. The guidance from professors made me realize the true value of justice and responsibility.",
            image: devid,
        },
        {
            id: 37,
            name: "Aashish Kumar Dewangan ",
            field: "LLB ",
            testimonial:
                "Every lecture at ISBM University inspired me to respect the law. This place gave me discipline along with education.",
            image: aashish_d,
        },
        {
            id: 38,
            name: "Yogesh Kumar Dahariya",
            field: "M.Sc Chemistry ",
            testimonial:
                "My love for Chemistry grew stronger here. The labs and faculty made every concept real and exciting.",
            image: yogesh_d,
        },
        {
            id: 39,
            name: "Yash Kumar",
            field: "MBA ",
            testimonial:
                "The MBA program taught me leadership, decision-making, and confidence. ISBM University feels like the right stepping stone for success.",
            image: yash,
        },
        {
            id: 40,
            name: "Aastha Dubey",
            field: "B.Com ",
            testimonial:
                "I gained both academic and life skills in my B.Com. journey. ISBM University is truly a place that shapes careers.",
            image: aastha,
        },
        {
            id: 41,
            name: "Sunita",
            field: "B.A ",
            testimonial:
                "The B.A. program taught me new perspectives on life. The friendly teachers at ISBM University encouraged me every step of the way.",
            image: sunita,
        },
        {
            id: 42,
            name: "Gunjan Sahu",
            field: "B.Com ",
            testimonial:
                "Studying commerce here gave me confidence in accounting and finance. ISBM University opened doors for my future.",
            image: gunjan,
        },
        {
            id: 43,
            name: "Hemlata",
            field: "B.A ",
            testimonial:
                "ISBM University gave me the courage to express my ideas and grow as an arts student.",
            image: hemlata,
        },
        {
            id: 44,
            name: "Palak Thakur",
            field: "B.Sc ",
            testimonial:
                "My B.Sc. journey was filled with experiments, projects, and wonderful memories. The staff at ISBM University always supported me.",
            image: palak,
        },
        {
            id: 45,
            name: "Roshanee Sahu",
            field: "B.A ",
            testimonial:
                "I feel proud to be a student here. ISBM University made me believe in myself and my abilities.",
            image: roshanee,
        },
        {
            id: 46,
            name: "Bushra Khan",
            field: "MBA ",
            testimonial:
                "My MBA experience taught me that learning never ends. The exposure and guidance from ISBM University shaped my career goals.",
            image: bushra,
        },
        {
            id: 47,
            name: "Suman Mannade",
            field: " M.Sc Zoology ",
            testimonial:
                "Studying Zoology here made me value science deeply. ISBM University has truly enriched my academic life.",
            image: suman,
        },
        {
            id: 48,
            name: "Divya Sahu",
            field: "M.Sc Zoology ",
            testimonial:
                "The personal attention from teachers gave me the courage to work harder. My ISBM University journey has been inspiring.",
            image: divya_s,
        },
        {
            id: 49,
            name: "Yeshu Verma",
            field: "BA LLB ",
            testimonial:
                "ISBM University showed me how law connects to society. The course made me stronger as a student and individual.",
            image: yeshu,
        },
        {
            id: 50,
            name: "Lakhan Lal Baghel",
            field: "LLB ",
            testimonial:
                "My dream of becoming a lawyer feels real now. The faculty at ISBM University guided me like mentors.",
            image: lakhan,
        },
        {
            id: 51,
            name: "Dikshit Kumar Sinha",
            field: "B.A ",
            testimonial:
                "ISBM University gave me new ideas and a chance to express myself in my B.A. studies.",
            image: dikshit,
        },
        {
            id: 52,
            name: "Kartik Yadav",
            field: "BA LLB ",
            testimonial:
                "BA LLB at ISBM University gave me both knowledge and the spirit to stand for justice.",
            image: kartik,
        },
        {
            id: 53,
            name: "Vikas Dubey",
            field: "B.A ",
            testimonial:
                "My B.A. course helped me grow as a thinker. ISBM University always encouraged me.",
            image: vikas,
        },
        {
            id: 54,
            name: "Akshat Jakhmola",
            field: "B.Pharm ",
            testimonial:
                "Studying Pharmacy here has been exciting. The practical labs gave me confidence to serve in the healthcare field.",
            image: akshat,
        },
        {
            id: 55,
            name: "Lukesh Kumar",
            field: "B.A ",
            testimonial:
                "My experience at ISBM University has been enriching. The teachers always motivated me to do better.",
            image: lukesh,
        },
        {
            id: 56,
            name: "Ojasva Chandrakar",
            field: "B.Sc ",
            testimonial:
                "The B.Sc. program gave me knowledge and discipline. ISBM University made learning enjoyable.",
            image: ojasva,
        },
        {
            id: 57,
            name: "Praveen Kumar Sahu",
            field: "B.A ",
            testimonial:
                "My B.A. journey has been full of encouragement. The staff here treat us with warmth and care.",
            image: praveen,
        },
        {
            id: 58,
            name: "Bedram Sahu",
            field: "B.Lib ",
            testimonial:
                "ISBM University gave me pride in learning Library Science. It has shaped my interest in managing knowledge.",
            image: bedram,
        },
        {
            id: 59,
            name: "Aashish Kumar",
            field: "LLB ",
            testimonial:
                "The LLB program gave me clarity about my future. ISBM University provided everything I needed to grow.",
            image: aashish_k,
        },
        {
            id: 60,
            name: "Riyansh Mittal",
            field: "B.Com ",
            testimonial:
                "Studying commerce here has given me both confidence and career focus. ISBM University changed my outlook.",
            image: riyansh,
        },
        {
            id: 61,
            name: "Bhaskar",
            field: "B.Lib ",
            testimonial:
                "My BLIB course taught me responsibility in managing knowledge. ISBM University gave me confidence for the future.",
            image: bhaskar,
        },
        {
            id: 62,
            name: "Piyush Yadav",
            field: "M.Sc Physics ",
            testimonial:
                "Physics felt alive in the labs at ISBM University. My professors made every concept meaningful.",
            image: piyush,
        },
        {
            id: 63,
            name: "Satya Patel",
            field: "M.Sc Microbiology ",
            testimonial:
                "My M.Sc. Microbiology journey at ISBM University has been full of learning and discovery. The well-equipped labs, supportive teachers, and caring staff made me feel confident and motivated. ISBM gave me both knowledge and memorable experiences that will always stay with me.",
            image: satya, // make sure you have imported satya image
        },
        {
            id: 64,
            name: "Ayush Ranjan",
            field: "B.Tech Mining ",
            testimonial:
                "Studying B.Tech Mining at ISBM University has been an exciting experience. The practical exposure, modern labs, and guidance from teachers gave me real confidence to work in the mining field. The support from staff and the friendly environment made my journey memorable.",
            image: ayush, // import ayush image
        },
        {
            id: 65,
            name: "Narayan Mohanty ",
            field: " B.Tech Mining ",
            testimonial:
                "My journey at ISBM University has been a good one. The teachers, labs, and staff support made learning easy and useful for my future.",
            image: narayan, // import narayan image
        },
        {
            id: 66,
            name: "Pravriti Pandey",
            field: "MBA ",
            testimonial:
                "My MBA journey at ISBM University has been very meaningful. The teachers explained concepts clearly, the staff were supportive, and the campus gave me confidence to grow in my career.",
            image: pravriti, // import pravriti image
        },

        {
            id: 4,
            name: "Vrishti Upadhyay",
            field: "BBA.LLB ",
            testimonial:
                "Studying BBA.LLB at ISBMU has been a great experience. The teachers are supportive, and the mix of law and management has helped me learn both theory and practical skills. I feel more confident about my future here.",
            image: vrishti,
        },
        {
            id: 11,
            name: "Divya Patel",
            field: "M.Sc Microbiology ",
            testimonial:
                "Studying M.Sc. Microbiology at ISBM University has been a good experience. The labs are well equipped, and the staff and admin are always supportive. The campus has good facilities which make learning easy.",
            image: divya,
        },
    ];

    const [activeSlide, setActiveSlide] = useState(0);

    const sliderSettings = {
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6500,
        pauseOnHover: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (_, next) => setActiveSlide(next),
    };

    return (
        <section className="alumni-modern" aria-labelledby="alumni-title">
            <div className="alumni-orb alumni-orb-one" aria-hidden="true"></div>
            <div className="alumni-orb alumni-orb-two" aria-hidden="true"></div>

            <div className="container mx-auto">
                <header className="alumni-modern-header">
                    <div>
                        <span className="alumni-kicker">
                            <i></i> Alumni stories
                        </span>
                        <h2 id="alumni-title">
                            Their journeys began here.
                            <em> Their impact travels further.</em>
                        </h2>
                    </div>

                    <div className="alumni-header-copy">
                        <p>
                            Meet the graduates turning knowledge into meaningful careers,
                            bold ideas and positive change across industries.
                        </p>
                        <a href="/alumni" className="alumni-view-all">
                            Explore our alumni network <span>↗</span>
                        </a>
                    </div>
                </header>

                <div className="alumni-stage">
                    <div className="alumni-stage-index" aria-hidden="true">
                        <span>{String(activeSlide + 1).padStart(2, "0")}</span>
                        <i></i>
                        <small>{String(alumniData.length).padStart(2, "0")}</small>
                    </div>

                    <Slider {...sliderSettings}>
                        {alumniData.map((item, index) => (
                            <article className="alumni-story" key={item.id}>
                                <div className="alumni-portrait-wrap">
                                    <div className="alumni-portrait-frame">
                                        <img
                                            src={item.image}
                                            alt={`${item.name}, ISBM University alumnus`}
                                            loading={index === 0 ? "eager" : "lazy"}
                                        />
                                    </div>

                                    <span className="alumni-portrait-label">
                                        Proud ISBMU Alumnus
                                    </span>

                                    <div className="alumni-photo-accent" aria-hidden="true">
                                        <span>ISBMU</span>
                                        <i>Alumni</i>
                                    </div>
                                </div>

                                <div className="alumni-story-content">
                                    <div className="alumni-quote-mark" aria-hidden="true">“</div>

                                    <span className="alumni-programme">
                                        {item.field || "ISBM University Graduate"}
                                    </span>

                                    <blockquote>{item.testimonial}</blockquote>

                                    <footer>
                                        <div>
                                            <h3>{item.name}</h3>
                                            <p>Alumni · ISBM University</p>
                                        </div>

                                        <a href="/alumni" className="alumni-story-link">
                                            <span>Read full story</span>
                                            <i>↗</i>
                                        </a>
                                    </footer>
                                </div>
                            </article>
                        ))}
                    </Slider>

                    <div className="alumni-progress">
                        <div className="alumni-progress-track">
                            <span
                                style={{
                                    width: `${((activeSlide + 1) / alumniData.length) * 100}%`,
                                }}
                            ></span>
                        </div>

                        <div className="alumni-progress-count">
                            <strong>{String(activeSlide + 1).padStart(2, "0")}</strong>
                            <span>/</span>
                            <small>{String(alumniData.length).padStart(2, "0")}</small>
                        </div>
                    </div>

                    <div className="alumni-trust-strip">
                        <span>One community</span>
                        <i></i>
                        <span>Many industries</span>
                        <i></i>
                        <span>Global ambitions</span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Alumni;

